module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "subpage affairs2"
  }, [_c('div', {
    staticClass: "pgLeft"
  }, [_vm._v("流程")]), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('el-button', {
    staticClass: "addbtn",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addPgress
    }
  }, [_vm._v("添加")]), _vm._v(" "), _vm._l((_vm.params.processFlowList), function(item, index) {
    return _c('div', {
      staticClass: "text-block clearfix"
    }, [_c('div', {
      staticClass: "bName"
    }, [_c('dic-select', {
      attrs: {
        "code": "bllc",
        "selectId": item.processTypeId,
        "paramsKey": index
      },
      on: {
        "selectChange": _vm.selectChange
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bContent"
    }, [_c('el-input', {
      staticClass: "inpText",
      attrs: {
        "type": "textarea",
        "rows": "5",
        "resize": "none",
        "size": "medium",
        "placeholder": "请输入内容"
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "rmbtn",
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.pgRemove(index)
        }
      }
    }, [_vm._v("删除")])], 1)])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-d38b303c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/affairs/src/Subpage2.vue
// module id = 1567
// module chunks = 1